<div class="container position-absolute top-50 start-50 translate-middle">
  <div class="card shadow px-5 py-4 mx-auto d-grid gap-3 card-login">
    <div class="mb-3 h5 fw-bold text-center">
      {{ 'app.forgotPassword.title' | translate }}
    </div>

    @if (currentStep === 1) {
      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSendCode()" class="d-grid gap-3">
        <div>
          <label for="email-input" class="form-label fw-bold">{{
            'app.forgotPassword.email' | translate
          }}</label>
          <input
            formControlName="email"
            type="text"
            class="form-control"
            id="input-email"
            required
          />
          <div class="text-danger">
            @if (emailControl?.invalid && (emailControl?.dirty || emailControl?.touched)) {
              @if (emailControl?.hasError('required')) {
                {{ 'app.forgotPassword.emailRequired' | translate }}
              }
              @if (emailControl?.hasError('email')) {
                {{ 'app.forgotPassword.emailValidate' | translate }}
              }
            }
          </div>
        </div>
        <div>
          <button
            [disabled]="isSendingCode"
            type="submit"
            class="btn btn-primary w-100 btn-login"
          >
            {{ 'app.forgotPassword.sendCode' | translate }}
            @if (isSendingCode) {
              <div
                class="spinner-border spinner-border-sm text-light"
                role="status"
              ></div>
            }
          </button>
        </div>
      </form>
    } @else {
      <form [formGroup]="resetPasswordForm" (ngSubmit)="onResetPassword()" class="d-grid gap-3">
        <div>
          <label for="code-input" class="form-label fw-bold">{{
            'app.forgotPassword.verificationCode' | translate
          }}</label>
          <div class="mb-2">
            {{ 'app.forgotPassword.codeSentMessage' | translate }}
          </div>
          <input
            formControlName="code"
            type="text"
            class="form-control"
            id="input-code"
            required
          />
          <div class="text-danger">
            @if (code?.invalid && (code?.dirty || code?.touched)) {
              @if (code?.hasError('required')) {
                {{ 'app.forgotPassword.codeRequired' | translate }}
              }
            }
          </div>
        </div>
        <div class="mb-2 text-center">
          <span>
            {{ 'app.forgotPassword.cannotReceiveCode' | translate }}
            <a (click)="onResendCode()" [class.disabled]="countdown > 0" class="ps-1">
              {{ 'app.forgotPassword.sendCode' | translate }}
              @if (countdown > 0) {
                <span>({{ countdown }}s)</span>
              }
            </a>
          </span>
        </div>
        <div>
          <label for="new-password-input" class="form-label fw-bold">{{
            'app.forgotPassword.newPassword' | translate
          }}</label>
          <input
            formControlName="newPassword"
            type="{{ isShowPwd.value ? 'text' : 'password' }}"
            class="form-control"
            id="input-new-password"
            required
          />
          <div class="text-danger">
            @if (newPassword?.invalid && (newPassword?.dirty || newPassword?.touched)) {
              @if (newPassword?.hasError('required')) {
                {{ 'app.forgotPassword.passwordRequired' | translate }}
              }
              @if (newPassword?.hasError('passwordPattern')) {
                {{ 'validation.passwordPattern' | translate }}
              }
            }
          </div>
        </div>
        <div class="form-check">
          <input
            [formControl]="isShowPwd"
            type="checkbox"
            class="form-check-input"
            id="show-password-checkbox"
          />
          <label for="show-password-checkbox" class="form-check-label">{{
            'app.forgotPassword.showPassword' | translate
          }}</label>
        </div>
        <div>
          <label for="confirm-password-input" class="form-label fw-bold">{{
            'app.forgotPassword.confirmPassword' | translate
          }}</label>
          <input
            formControlName="confirmPassword"
            type="{{ isShowConfirmPwd.value ? 'text' : 'password' }}"
            class="form-control"
            id="input-confirm-password"
            required
          />
          <div class="text-danger">
            @if (confirmPassword?.invalid && (confirmPassword?.dirty || confirmPassword?.touched)) {
              @if (confirmPassword?.hasError('required')) {
                {{ 'app.forgotPassword.confirmPasswordRequired' | translate }}
              }
              @if (confirmPassword?.hasError('passwordMismatch')) {
                {{ 'app.forgotPassword.passwordsDoNotMatch' | translate }}
              }
            }
          </div>
        </div>
        <div class="form-check">
          <input
            [formControl]="isShowConfirmPwd"
            type="checkbox"
            class="form-check-input"
            id="show-confirm-password-checkbox"
          />
          <label for="show-confirm-password-checkbox" class="form-check-label">{{
            'app.forgotPassword.showPassword' | translate
          }}</label>
        </div>
        <div>
          <button
            [disabled]="isResetting"
            type="submit"
            class="btn btn-primary w-100 btn-login"
          >
            {{ 'app.forgotPassword.resetPassword' | translate }}
            @if (isResetting) {
              <div
                class="spinner-border spinner-border-sm text-light"
                role="status"
              ></div>
            }
          </button>
        </div>
      </form>
    }

    <div class="text-center">
      <a routerLink="/auth/login" class="ps-1">{{
        'app.forgotPassword.backToLogin' | translate
      }}</a>
    </div>
  </div>
</div>